<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <page-header title="Painel de controle" subTitle="Visão Global" />

    <d-row>
      <!-- Users Overview -->
      <d-col lg="8" md="6" sm="12" class="mb-4">
        <!-- <bo-users-overview /> -->
      </d-col>

      <!-- Users by Device (lite) -->
      <d-col lg="4" md="6" sm="12" class="mb-4">
        <!-- <bo-users-by-device /> -->
      </d-col>
    </d-row>

    <d-row>
      <!-- Last Registers -->
      <d-col lg="6" md="12" sm="12" class="mb-4">
        <!-- <last-Registers /> -->
      </d-col>

      <!-- Registers list by status -->
      <d-col lg="6" md="12" sm="12" class="mb-4">
        <!-- <status-Registers /> -->
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import PageHeader from '_shared/PageHeader.vue';

export default {
  name: 'dashboard',
  components: {
    PageHeader,
  },
};
</script>
